<template>
  <div class="shipping-page">
    <div class="page-header">
      <div class="back-btn" @click="goBack">{{ $t('wholesaler.AfterSalesShippingPage.line4_text') }}</div>
      <h1>{{ isResend ? '补发确认' : '换货发货' }} / {{ isResend ? 'Resend' : 'Exchange' }} Shipping</h1>
      <div class="sub">{{ detail.afterSalesNo }}</div>
    </div>

    <div v-loading="loading" class="content">
      <!-- 概要 -->
      <div class="module">
        <div class="module-header"><span class="icon">📋</span><span class="title">{{ $t('wholesaler.AfterSalesShippingPage.line12_text') }}</span></div>
        <div class="module-body">
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesShippingPage.line14_text') }}</span><span class="value">{{ schemeText(detail.resolutionType) }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesShippingPage.line15_text') }}</span><span class="value">{{ detail.resendWarehouseName || '-' }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesShippingPage.line16_text') }}</span><span class="value" style="text-align:right;">{{ deliveryAddress }}</span></div>
        </div>
      </div>

      <!-- 发出商品清单 -->
      <div class="module">
        <div class="module-header"><span class="icon">📦</span><span class="title">{{ $t('wholesaler.AfterSalesShippingPage.line22_text') }}</span></div>
        <div class="module-body">
          <div class="item-row" v-for="item in resendItemsList" :key="item.productId || item.id">
            <span class="item-name">{{ item.productName || '商品' }}</span>
            <span class="item-qty">× {{ item.quantity }}</span>
            <span class="item-stock" :class="stockClass(item)">库存: {{ item.stockQty || '✓' }}</span>
          </div>
        </div>
      </div>

      <!-- 操作区 -->
      <div class="module action-section">
        <div class="module-body">
          <div v-if="detail.resolutionStatus === 'RESEND_SHIPPING' || detail.resolutionStatus === 'EXCHANGE_SHIPPING'">
            <el-button type="primary" size="large" style="width:100%;height:48px;" @click="confirmShip" :loading="submitting">
              📮 确认发货
            </el-button>
          </div>
          <div v-else-if="detail.resolutionStatus === 'RESEND_DELIVERED' || detail.resolutionStatus === 'EXCHANGE_DELIVERED'">
            <el-button type="success" size="large" style="width:100%;height:48px;" @click="confirmReceive" :loading="submitting">
              ✅ 客户已确认收到
            </el-button>
          </div>
          <div v-else>
            <el-alert :title="'当前状态: ' + detail.resolutionStatus" type="info" :closable="false"></el-alert>
          </div>
        </div>
      </div>

      <!-- 操作日志 -->
      <div class="module">
        <div class="module-header"><span class="icon">📝</span><span class="title">{{ $t('wholesaler.AfterSalesShippingPage.line53_text') }}</span></div>
        <div class="module-body">
          <div v-if="actions.length > 0">
            <div class="log-item" v-for="log in actions" :key="log.id">
              <div class="log-dot"></div>
              <div class="log-content">
                <div class="log-title">{{ log.actionType }}</div>
                <div class="log-note" v-if="log.note">{{ log.note }}</div>
                <div class="log-time">{{ log.createdAt }}</div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state"><div class="empty-icon">📄</div><div class="empty-text">{{ $t('wholesaler.AfterSalesShippingPage.line65_text') }}</div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAfterSalesDetail, getAfterSalesActions, confirmShip, confirmReceiveNew } from '@/services/afterSales';

export default {
  name: 'AfterSalesShippingPage',
  data() {
    return {
      loading: false,
      submitting: false,
      detail: {},
      actions: []
    };
  },
  computed: {
    isResend() {
      return this.detail.resolutionType === 'RESEND';
    },
    resendItemsList() {
      try {
        const items = this.detail.resendItems ? JSON.parse(this.detail.resendItems) : [];
        if (items.length > 0) return items;
        const applyItems = this.detail.applyItems ? JSON.parse(this.detail.applyItems) : [];
        return applyItems.map(i => ({ productId: i.productId || i.orderItemId, productName: i.productName, quantity: i.quantity }));
      } catch { return []; }
    },
    deliveryAddress() {
      return this.detail.customerAddress || '（从订单获取）';
    }
  },
  created() { this.loadDetail(); },
  methods: {
    async loadDetail() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        this.detail = await getAfterSalesDetail(id);
        this.actions = await getAfterSalesActions(id);
      } catch (e) {
        this.$message.error('加载失败: ' + (e.message || e));
      } finally { this.loading = false; }
    },
    goBack() { this.$router.back(); },
    schemeText(type) { const m = { RETURN_REFUND:'退货退款', EXCHANGE:'换货', RESEND:'补发', PARTIAL_REFUND:'部分退款', RELIEF:'减免', NO_ACTION:'不处理' }; return m[type] || type; },
    stockClass(item) { return item.stockQty <= 0 ? 'low-stock' : 'ok-stock'; },
    async confirmShip() {
      this.submitting = true;
      try {
        await confirmShip(this.detail.id);
        this.$message.success('已确认发货');
        this.loadDetail();
      } catch (e) {
        this.$message.error('发货失败: ' + (e.message || e));
      } finally { this.submitting = false; }
    },
    async confirmReceive() {
      this.submitting = true;
      try {
        await confirmReceiveNew(this.detail.id);
        this.$message.success('售后流程已完成');
        this.$router.push(`/wholesaler/after-sales/${this.detail.id}`);
      } catch (e) {
        this.$message.error('操作失败: ' + (e.message || e));
      } finally { this.submitting = false; }
    }
  }
};
</script>

<style scoped>
.page-header { background: linear-gradient(135deg, #722ed1, #b37feb); color: #fff; padding: calc(16px + env(safe-area-inset-top, 0px)); }
.back-btn { font-size: 12px; opacity: 0.8; cursor: pointer; margin-bottom: 4px; }
.back-btn:hover { opacity: 1; }
.page-header h1 { font-size: 17px; }
.page-header .sub { font-size: 12px; opacity: 0.8; }

.content { max-width: 600px; margin: 0 auto; padding-bottom: 60px; background: #f5f5f5; min-height: calc(100vh - 80px); }

.module { margin: 8px; background: #fff; border-radius: 8px; overflow: hidden; }
.module-header { display: flex; align-items: center; padding: 12px 12px 8px; gap: 6px; border-bottom: 1px solid #f0f0f0; }
.module-header .icon { font-size: 16px; }
.module-header .title { font-size: 14px; font-weight: 600; flex: 1; }
.module-body { padding: 12px; }

.row { display: flex; justify-content: space-between; padding: 8px 0; font-size: 13px; }
.row .label { color: #999; }
.row .value { font-weight: 500; text-align: right; }
.row + .row { border-top: 1px dashed #f0f0f0; }

.item-row { display: flex; align-items: center; gap: 8px; padding: 8px 0; border-bottom: 1px dashed #f0f0f0; }
.item-row:last-child { border-bottom: none; }
.item-name { flex: 1; font-size: 13px; font-weight: 500; }
.item-qty { font-size: 12px; color: #999; }
.item-stock { font-size: 11px; }
.ok-stock { color: #52c41a; }
.low-stock { color: #ff4d4f; }

.action-section { border: 2px solid #1890ff; }

.log-item { display: flex; gap: 8px; padding: 8px 0; border-bottom: 1px solid #f5f5f5; }
.log-item:last-child { border-bottom: none; }
.log-dot { width: 6px; height: 6px; border-radius: 50%; background: #457b9d; margin-top: 5px; flex-shrink: 0; }
.log-content { flex: 1; }
.log-title { font-size: 12px; font-weight: 500; }
.log-note { font-size: 11px; color: #666; margin-top: 1px; }
.log-time { font-size: 10px; color: #bbb; margin-top: 2px; }
.empty-state { text-align: center; padding: 24px 0; color: #999; }
.empty-icon { font-size: 32px; margin-bottom: 8px; }
.empty-text { font-size: 13px; }
</style>
